import styles from './index.module.less'
import { Col, Row, Image } from 'antd'
import { Scrollbars } from 'react-custom-scrollbars'
import { useFileUrlPrefix } from 'shj-utils'
import dayjs from 'dayjs'
import { useCallback, useEffect, useRef } from 'react'
import { debounce } from 'lodash-es'

const WOTabItemList = props => {
  const { dataSource, noMore, loading, fetchPrev, fetchNext, tab, onClick, filePrefix } = props
  const scrollTopRef = useRef(0)

  const handleScrollFrame = values => {
    if (values.top === 0) {
      fetchPrev?.(dataSource[0])
    }
    const { scrollHeight, clientHeight, scrollTop } = values
    if (
      scrollHeight - scrollTop - clientHeight <= clientHeight * 0.2 &&
      scrollTopRef.current < values.top
    ) {
      fetchNext?.(dataSource[dataSource.length - 1])
    }
    scrollTopRef.current = values.top
  }

  useEffect(() => {
    // console.log(window.innerHeight)
    // window.addEventListener('resize', () => {
    //   console.log(window.innerHeight)
    // })
  }, [])

  return (
    <div className={styles.list}>
      <Scrollbars
        autoHide
        renderTrackHorizontal={() => <div></div>}
        onScrollFrame={handleScrollFrame}
      >
        <div className={styles.content}>
          {dataSource.map((d, i) => {
            return (
              <div key={d.id} className={styles.item} onClick={() => onClick?.(d, tab)}>
                <Row gutter={12} wrap={false}>
                  <Col>
                    <Image src={d.appIcon?.startsWith?.('http') ? d.appIcon : filePrefix + d.appIcon} preview={false} width={30} />
                  </Col>
                  <Col flex={1}>
                    <div className={styles.itemTitle}>
                      <Row gutter={15}>
                        <Col>{d.appName}</Col>
                        <Col>{dayjs(d.createdTime).format('YYYY-MM-DD HH:mm:ss')}</Col>
                      </Row>
                    </div>
                    <div className={styles.itemContent}>
                      {d.starterName ? d.starterName + '-' : ''} {d.content}
                    </div>
                  </Col>
                </Row>
              </div>
            )
          })}
          <div className={styles.listState}>
            {noMore && !loading ? '没有更多了' : ''}
            {loading === 1 ? '加载中...' : ''}
          </div>
        </div>
      </Scrollbars>
    </div>
  )
}

export default WOTabItemList
